import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss']
})
export class MultiselectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
